import { Dropdown, MenuProps, Spin } from "antd";
import { FC } from "react";

import FlexContainer from "@/components/FlexContainer";
import { PrimaryText } from "@/components/Typography/Styled";

import {
    StyledLoadingOutlined,
    StyledUploadOutlinedBig,
    StyledUploadOutlinedSmall,
} from "./Styled";

interface ExportDropdownProps {
    isLoading: boolean;
    loadingLabel?: string | number;
    menuItems: MenuProps["items"];
    onMenuClick: MenuProps["onClick"];
}

const ExportDropdown: FC<ExportDropdownProps> = ({
    isLoading,
    loadingLabel,
    menuItems,
    onMenuClick,
}) => {
    const loadingContent = (
        <FlexContainer flexDirection="column" alignItems="center" gap="4px">
            <StyledUploadOutlinedSmall />
            <FlexContainer gap="4px">
                <Spin size="small" indicator={<StyledLoadingOutlined spin />} />
                <PrimaryText
                    fontSize={12}
                    fontWeight="600"
                    style={{ lineHeight: 1 }}
                >
                    {loadingLabel}
                </PrimaryText>
            </FlexContainer>
        </FlexContainer>
    );

    const renderTrigger = () => {
        if (isLoading) {
            return (
                <FlexContainer onClick={(e) => e.stopPropagation()}>
                    {loadingContent}
                </FlexContainer>
            );
        }

        return <StyledUploadOutlinedBig onClick={(e) => e.stopPropagation()} />;
    };

    if (isLoading) {
        return renderTrigger();
    }

    return (
        <Dropdown
            trigger={["click"]}
            menu={{ items: menuItems, onClick: onMenuClick }}
        >
            {renderTrigger()}
        </Dropdown>
    );
};

export default ExportDropdown;
